import BlurredBackground from '$tablet-app/src/app/components/BlurredBackground';
import { useWindowDimensions } from 'react-native';
import { Overlay } from 'react-native-elements';

interface Props {
  visible?: boolean;
  children: React.ReactNode;
}

export const LockScreenOverlay = ({ visible, children }: Props) => {
  const { height, width } = useWindowDimensions();

  return (
    <Overlay
      isVisible={!!visible}
      animationType="fade"
      transparent
      overlayStyle={{
        height,
        width,
        backgroundColor,
      }}
    >
      <BlurredBackground />
      {children}
    </Overlay>
  );
};

const backgroundColor = 'rgba(5, 22, 51, 0.2)';
